import React, { useState, useEffect } from "react";

import { Box, Stack, Select, MenuItem } from "@mui/material";

export default function SelectInput({
   style,
   direction,
   size,
   label,
   value,
   boolean,
   options,
   callback,
}) {
   const [currentValue, setCurrentValue] = useState(value);

   useEffect(() => {
      if (currentValue != value) {
         setCurrentValue(value);
      }
   }, [value]);

   const updateValue = (e) => {
      setCurrentValue(e.target.value);
   };

   useEffect(() => {
      // console.log("current value set to " + currentValue);
      if (value != currentValue) {
         callback(currentValue);
      }
   }, [currentValue]);

   // Determine if options is array of objects with 'value' and 'label'
   const isObjOptions =
      Array.isArray(options) &&
      options.length > 0 &&
      typeof options[0] === "object" &&
      options[0] !== null &&
      "value" in options[0] &&
      "label" in options[0];

   return (
      <Stack
         spacing={2}
         direction={direction ? direction : "row"}
         alignItems='center'
         sx={{ width: "100%" }}
      >
         <Box>{label}</Box>
         <Select
            value={currentValue}
            onChange={updateValue}
            size={size}
            fullWidth
            sx={{ ...style }}
         >
            {isObjOptions
               ? options.map((option) => (
                    <MenuItem key={label + "-" + option.value} value={option.value}>
                       {option.label}
                    </MenuItem>
                 ))
               : options.map((option) => (
                    <MenuItem key={label + "-" + option} value={option}>
                       {boolean ? new Boolean(option).toString() : option}
                    </MenuItem>
                 ))}
         </Select>
      </Stack>
   );
}
